import CodeBlock from "../../common/code_block";
import ErrorCodesLink from "../../common/ErrorCodesLink";
import EnvelopeRows from "../../common/EnvelopeRows";
import HeaderWithTag from "../../common/header_with_tag";
import { ICredentials } from "../../types/types";
import { Link } from 'react-router-dom';
import { HOST_API_URL } from "../../config";
import TryGetCountryServices from "./try";


const responseCode = `{
  "statusCode": 200,
  "message": "Success",
  "errorCode": null,
  "data": [
    {
      "countryCode": "SO",
      "countryName": "SOMALIA",
      "service": "Cash PICKUP"
    },
    {
      "countryCode": "SO",
      "countryName": "SOMALIA",
      "service": "Account Transfer"
    },
    {
      "countryCode": "SO",
      "countryName": "SOMALIA",
      "service": "Mobile Transfer"
    }
  ]
}`;

function GetCountryServices() {
  return (
    <div className="page">
      <div className="app-content main-content mt-0">
        <div className="side-app">
          <div className="main-container container-fluid">
            <div className="page-header">
              <div>
                <h1 className="page-title">Get Country Services</h1>
              </div>
              <div className="ms-auto pageheader-btn">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="javascript:void(0);">Docs</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Get Country Services
                  </li>
                </ol>
              </div>
            </div>

            <div className="card overflow-hidden">
              <div className="row">
                <div className="col-md-7" style={{ position: "relative" }}>
                  <div className="card-body border-end p-0">
                    <div className="p-5">
                      <HeaderWithTag
                        headerText="Retrieve available services for a specific country"
                        headerTag="description"
                      />
                      <p className="text-12">
                        <span className="badge badge-sm bg-blue text-white me-2">
                          GET
                        </span>
                        {HOST_API_URL}/Common/GetCountryServices?countryCode=SO
                      </p>
                      <p className="text-muted text-14" style={{ textAlign: "justify" }}>
                        Returns the list of available remittance services for the specified country code.
                        Use this to determine supported payout methods like Cash Pickup, Account Transfer, or Mobile Transfer.
                      </p>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Query Parameters"
                          headerTag="parameters"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameters</th>
                                <th>Type</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>countryCode</td>
                                <td>string</td>
                                <td>ISO country code (e.g., SO for Somalia). Required.</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p className="text-muted text-14 mb-0">
                          Omitting <code>countryCode</code>, or sending it empty, returns 400
                          with DPI-1000. An unknown code, or a country with no configured
                          services, still succeeds with <code>data: null</code> (not an empty
                          array); treat null as "no services".
                        </p>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Response"
                          headerTag="response"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameters</th>
                                <th>Type</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <EnvelopeRows />
                              <tr>
                                <td>data[].countryCode</td>
                                <td>string</td>
                                <td>ISO country code</td>
                              </tr>
                              <tr>
                                <td>data[].countryName</td>
                                <td>string</td>
                                <td>Full country name</td>
                              </tr>
                              <tr>
                                <td>data[].service</td>
                                <td>string | null</td>
                                <td>Available service type</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={responseCode}
                          codeBlackText="Response Simple"
                          codeLanguage="json"
                        />
                      </div>

                      <ErrorCodesLink />
                    </div>
                  </div>
                </div>
                <div className="col-md-5 pt-5">
                  <h5 className="card-title text-primary">
                     Code Samples
                  </h5>

                  <TryGetCountryServices
                    codeBlackTitle="Request Simple"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GetCountryServices;